import React, {  Component } from 'react';

export default class SelectionsNotConfirmed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog("SelectionsNotConfirmed", false);
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="selectionsNotConfirmed">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Selections Not Confirmed</h2>
					<p><b>Are you sure you want to leave this page?</b></p>
                    <p>Any selections you made have not been confirmed.</p>
					<a className="blueButton noButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
					<a className="blueButton yesButton" onClick={this.props.handleLeaveThisPage.bind(this)}>Yes</a>
				</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/selectionsNotConfirmed.js